<template>
  <div class="home" :class="{ 'dark-mode': isDarkMode }">
    <Background v-if="mobile" :isDarkMode="isDarkMode" />

    <header class="nav">
      <div class="logo">Ejikeme David</div>
      <div class="mode">
        <i :class="isDarkMode ? 'fa-solid fa-moon' : 'fa-solid fa-sun'" @click="toggleTheme" />
      </div>
      <nav class="nav-menu" :class="{ 'menu-hidden': !isOpen }">
        <ul>
          <li><a href="#home" :class="{ active: activeLink === 'home' }" @click="setActiveLink('home')">Home</a></li>
          <li><a href="#about" :class="{ active: activeLink === 'about' }" @click="setActiveLink('about')">About</a></li>
          <li><a href="#services" :class="{ active: activeLink === 'services' }"
              @click="setActiveLink('services')">Services</a></li>
          <li><a href="#skills" :class="{ active: activeLink === 'skills' }" @click="setActiveLink('skills')">Skills</a>
          </li>
          <li><a href="#projects" :class="{ active: activeLink === 'projects' }"
              @click="setActiveLink('projects')">Projects</a></li>
          <li><a href="#contact" :class="{ active: activeLink === 'contact' }"
              @click="setActiveLink('contact')">Contact</a></li>
        </ul>
      </nav>

      <div class="menu-icon" @click="toggleNav">
        <i :class="['fa-solid', isOpen ? 'fa-xmark' : 'fa-bars']"></i>
      </div>

    </header>

    <!-- Landing Section -->
    <section class="landing" id="home">
      <div class="container">
        <div class="content" data-aos="fade-right" data-aos-easing="ease-in" data-aos-duration="900"
          data-aos-anchor-placement="top">
          <h3>Hi! I'm <span>David</span></h3>
          <h4>And i'm a <span ref="typedOutput"></span></h4>
          <p>Welcome to my portfolio. I specialize in crafting stunning websites and web applications. Let's connect and
            find how i can be of help to you.</p>
          <div class="btn-box">
            <a href="../assets/docs/EjikemeDavid_CV.pdf" class="btn" download="EjikemeDavid_cv.pdf">Download CV</a>
            <a href="#contact" class="btn">Hire Me Now!</a>
          </div>
          <div class="socials">
            <a href="https://www.linkedin.com/in/ejikeme-david-8b6a61295/" target="_blank" rel="noopener"><i
                class="fa-brands fa-linkedin"></i></a>
            <a href="https://github.com/David-Hunt327"  target="_blank" rel="noopener"><i
                class="fa-brands fa-github"></i></a>
          </div>
        </div>
        <div class="landing-image" data-aos="fade-left" data-aos-easing="ease-in" data-aos-duration="900"
          data-aos-anchor-placement="top">
          <div class="img-box index">
            <img src="" alt="Profile_Picture" class="index">
          </div>

          <div class="bubble">
            <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              width="100%" id="blobSvg">
              <!-- <path fill="#ffffff"> -->
              <path :fill="{ 'dark-mode': isDarkMode }">
                <animate attributeName="d" dur="20000ms" repeatCount="indefinite" values="M410.47098,324.95647Q368.91295,399.91295,294.13058,393.20201Q219.34821,386.49108,
                149.06585,359.55692Q78.78348,332.62277,70.26897,246Q61.75446,159.37723,136.46428,
                119.05134Q211.17411,78.72544,271.73884,112.79799Q332.30357,146.87053,392.1663,
                198.43527Q452.02902,250,410.47098,324.95647Z; 
              
                M396.5,302Q333,354,274,378.5Q215,403,170,356.5Q125,310,126,250.5Q127,191,167,126.5Q207,62,276,
                96.5Q345,131,402.5,190.5Q460,250,396.5,302Z;

                M412.5,322Q365,394,290,398Q215,402,124,378.5Q33,355,67,266.5Q101,178,150,103Q199,28,
                276.5,73.5Q354,119,407,184.5Q460,250,412.5,322Z;

                M434.5,337.5Q390,425,292.5,458.5Q195,492,116.5,422Q38,352,66,263.5Q94,175,152,125Q210,
                75,302,72.5Q394,70,436.5,160Q479,250,434.5,337.5Z;

                M427.5,343Q398,436,300,448.5Q202,461,132,401Q62,341,92,264.5Q122,188,159,101Q196,
                14,269,74Q342,134,399.5,192Q457,250,427.5,343Z;

                M402.5,334Q384,418,300,408Q216,398,131,373Q46,348,63,258Q80,
                168,141.5,107Q203,46,276,86Q349,126,385,188Q421,250,402.5,334Z;

                M415,305.5Q339,361,278,378Q217,395,140,367.5Q63,340,89.5,262.5Q116,185,158.5,
                110.5Q201,36,276,80Q351,124,421,187Q491,250,415,305.5Z;

                M410.47098,324.95647Q368.91295,399.91295,294.13058,393.20201Q219.34821,386.49108,
                149.06585,359.55692Q78.78348,332.62277,70.26897,246Q61.75446,159.37723,136.46428,
                119.05134Q211.17411,78.72544,271.73884,112.79799Q332.30357,146.87053,392.1663,
                198.43527Q452.02902,250,410.47098,324.95647Z;
                ">

                </animate>
              </path>
            </svg>
          </div>

          <div class="bubble">
            <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              width="100%" id="blobSvg">
              <path fill="#ffffff">
                <animate attributeName="d" dur="20000ms" repeatCount="indefinite" values="M410.47098,324.95647Q368.91295,399.91295,294.13058,393.20201Q219.34821,386.49108,
                149.06585,359.55692Q78.78348,332.62277,70.26897,246Q61.75446,159.37723,136.46428,
                119.05134Q211.17411,78.72544,271.73884,112.79799Q332.30357,146.87053,392.1663,
                198.43527Q452.02902,250,410.47098,324.95647Z; 
              
                M396.5,302Q333,354,274,378.5Q215,403,170,356.5Q125,310,126,250.5Q127,191,167,126.5Q207,62,276,
                96.5Q345,131,402.5,190.5Q460,250,396.5,302Z;

                M412.5,322Q365,394,290,398Q215,402,124,378.5Q33,355,67,266.5Q101,178,150,103Q199,28,
                276.5,73.5Q354,119,407,184.5Q460,250,412.5,322Z;

                M434.5,337.5Q390,425,292.5,458.5Q195,492,116.5,422Q38,352,66,263.5Q94,175,152,125Q210,
                75,302,72.5Q394,70,436.5,160Q479,250,434.5,337.5Z;

                M427.5,343Q398,436,300,448.5Q202,461,132,401Q62,341,92,264.5Q122,188,159,101Q196,
                14,269,74Q342,134,399.5,192Q457,250,427.5,343Z;

                M402.5,334Q384,418,300,408Q216,398,131,373Q46,348,63,258Q80,
                168,141.5,107Q203,46,276,86Q349,126,385,188Q421,250,402.5,334Z;

                M415,305.5Q339,361,278,378Q217,395,140,367.5Q63,340,89.5,262.5Q116,185,158.5,
                110.5Q201,36,276,80Q351,124,421,187Q491,250,415,305.5Z;

                M410.47098,324.95647Q368.91295,399.91295,294.13058,393.20201Q219.34821,386.49108,
                149.06585,359.55692Q78.78348,332.62277,70.26897,246Q61.75446,159.37723,136.46428,
                119.05134Q211.17411,78.72544,271.73884,112.79799Q332.30357,146.87053,392.1663,
                198.43527Q452.02902,250,410.47098,324.95647Z;
                ">

                </animate>
              </path>
            </svg>
          </div>
        </div>
      </div>
    </section>
    <!--X Landing Section X-->

    <!-- About Me Section -->
    <section id="about" class="about">
      <AboutMe />
    </section>
    <!--X About Me Section X-->

    <!-- Services Section -->
    <section id="services" class="services">
      <Services />
    </section>
    <!--x Services Section x-->

    <!-- Skills Section -->
    <section id="skills" class="skills">
      <SkillsCategory />
    </section>
    <!--x Skills Section x-->

    <!-- Projects Section -->
    <section id="projects" class="projects">
      <ProjectsCategory />
    </section>
    <!--x Projects Section x-->


    <!-- Contact Section -->
    <section class="contact" id="contact">
      <div class="container">
        <div class="intro" data-aos="fade-down" data-aos-easing="ease-in-out" data-aos-duration="800"
          data-aos-anchor-placement="top">
          <p class="section_p1">Let's Get In Touch!</p>
          <h1 class="title">Contact Me</h1>
        </div>

        <div class="form">
          <form @submit.prevent="submitForm">
            <loading v-show="loading" />
            <!-- <loading /> -->

            <input type="text" placeholder="Your Name" data-aos="fade-up" data-aos-easing="ease-in-out"
              data-aos-duration="800" v-model="clientName">
            <input type="text" placeholder="Your Email" data-aos="fade-up" data-aos-easing="ease-in-out"
              data-aos-duration="850" v-model="clientEmail">
            <input type="number" placeholder="Phone Number" data-aos="fade-up" data-aos-easing="ease-in-out"
              data-aos-duration="900" v-model="clientPhoneNumber">
            <input type="text" placeholder="Email Subject" data-aos="fade-up" data-aos-easing="ease-in-out"
              data-aos-duration="950" v-model="emailSubject">
            <textarea cols="30" rows="10" placeholder="Your Massage 🙂" data-aos="fade-up" data-aos-easing="ease-in-out"
              data-aos-duration="1000" v-model="clientRequest"></textarea>
            <div class="box-btn form-btn" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="1100">
              <button type="submit" class="btn" @click="submitRequest" :class="{ 'shake': shakeEffect }">Send a
                message</button>
            </div>

            <div class="modal" v-if="showModal">
              <div class="modal-content">
                <span class="close" @click="closeModal">
                  <i class="fa-regular fa-circle-xmark" />
                </span>
                <div class="tick-container">
                  <img src="../assets/check-mark.gif">
                </div>
                <p>Your proposal was successfully submitted!</p>
              </div>
            </div>
          </form>


        </div>
      </div>
    </section>
    <!--x Contact Section x-->

    <footer class="footer">
      <p>Ejikeme David || <a href="mailto:Ejikemedavid212@proton.me">Ejikemedavid212@proton.me</a></p>
    </footer>
  </div>
</template>

<script>
import Typed from 'typed.js'
import { db } from '@/firebase/FirebaseInit'
import { addDoc, collection } from 'firebase/firestore'
import { uid } from 'uid'
import Loading from '@/components/Loading.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import Background from '@/components/Background.vue'
import AboutMe from '@/components/AboutMe.vue'
import Services from '@/components/Services.vue'
import SkillsCategory from '@/components/SkillsCategory.vue'
import ProjectsCategory from '@/components/ProjectsCategory.vue'


export default {
  name: 'HomeView',
  data() {
    return {
      isOpen: false,
      currentYear: null,
      activeLink: '',
      shakeEffect: false,
      showModal: false,
      mobile: null,

      clientName: '',
      clientEmail: '',
      clientPhoneNumber: '',
      emailSubject: '',
      clientRequest: '',
      docId: null,
      requestSubmitted: null,
      submissionDate: null,
      submissionDateUnix: null,

      dateOptions: { year: 'numeric', month: 'short', day: 'numeric' },
      loading: null,
      visitorData: null,


      sections: [
        { id: 'home', title: 'Home' },
        { id: 'about', title: 'About Me' },
        { id: 'services', title: 'Services' },
        { id: 'skills', title: 'My Skills' },
        { id: 'projects', title: 'My Projects' },
        { id: 'contact', title: 'Contact Me' },
      ],
    }
  },

  components: {
    Loading, Background, AboutMe, Services, SkillsCategory, ProjectsCategory
  },

  created() {
    // this.checkScreen();
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);

    this.submissionDateUnix = Date.now();
    this.submissionDate = new Date(this.submissionDateUnix).toLocaleDateString('en-us', this.dateOptions);
    this.captureVisitorInformation();
  },

  async mounted() {
    this.getCurrentYear();

    this.initializeTyped();


    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      this.isDarkMode = storedTheme === 'dark';
    } else {
      this.isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    };


    window.addEventListener('scroll', this.updateActiveLinkOnScroll);

    window.addEventListener('scroll', this.setDocumentTitle);

  },

  methods: {
    ...mapActions(['GET_PROPOSALS', 'STORE_VISITOR_DATA']),

    ...mapMutations(['TOGGLE_DARK_MODE']),

    checkScreen() {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 750) {
        this.mobile = false;
        return;
      }
      this.mobile = true;
    },

    setDocumentTitle() {
      for (const section of this.sections) {
        const element = document.getElementById(section.id);
        const rect = element.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom >= 0) {
          document.title = `${section.title} || Ejikeme David`;
          break;
        }
      }
    },

    setActiveLink(link) {
      this.activeLink = link;
      this.isOpen = false;
    },

    toggleNav() {
      this.isOpen = !this.isOpen;
    },

    getCurrentYear() {
      const now = new Date();
      this.currentYear = now.getFullYear();
    },

    initializeTyped() {
      const options = {
        strings: ["Web Developer", "Freelancer", "Programmer", "Tutor"],
        typeSpeed: 150,
        backSpeed: 100,
        startDelay: 500,
        backDelay: 1500,
        showCursor: true,
        loop: true,
      };

      const typed = new Typed(this.$refs.typedOutput, options);
    },

    submitRequest() {
      this.requestSubmitted = true;
    },

    submitForm() {
      if (this.validateForm()) {
        this.uploadForm();
      } else {
        this.showValidationToast();
        this.shakeEffect = true;
        setTimeout(() => {
          this.shakeEffect = false;
        }, 1000);
      }
    },

    validateForm() {
      return (
        this.clientName.trim() !== '' &&
        this.clientEmail.trim() !== '' &&
        this.clientPhoneNumber.toString().trim() !== '' &&
        this.emailSubject.trim() !== '' &&
        this.clientRequest.trim() !== ''
      );
    },

    showValidationToast() {
      this.$toast.open({
        message: 'Please ensure you fill out all the required Information!!!',
        type: 'error',
        position: 'bottom-right',
        duration: 3000,
      });
    },

    resetForm() {
      this.clientName = '';
      this.clientEmail = '';
      this.clientPhoneNumber = '';
      this.emailSubject = '';
      this.clientRequest = '';
    },

    closeModal() {
      this.showModal = false;
    },

    async uploadForm() {
      this.loading = true;

      try {
        const dataBase = await addDoc(collection(db, 'invitations'), {
          proposalId: uid(6),
          clientName: this.clientName,
          clientEmail: this.clientEmail,
          clientPhoneNumber: this.clientPhoneNumber,
          emailSubject: this.emailSubject,
          clientRequest: this.clientRequest,
          requestSubmitted: this.requestSubmitted,
          submissionDate: this.submissionDate,
          submissionDateUnix: this.submissionDateUnix,
          status: 'Pending'
        });

        this.$toast.open({
          message: 'Proposal successfully sent!!!',
          type: 'success',
          position: 'bottom-right',
          duration: 3000,
        });

        this.loading = false;
        this.showModal = true;
        this.resetForm();
        // this.GET_PROPOSALS();

      } catch (error) {
        console.error('Error submitting proposal:', error);
        this.$toast.open({
          message: 'Error submitting proposal.. Please try again.',
          type: 'error',
          position: 'bottom-right',
          duration: 3000,
        });
        this.loading = false;
      }
    },

    async captureVisitorInformation() {
      try {
        const locationData = await this.captureLocation();
        const currentDate = new Date().toLocaleDateString('en-us', this.dateOptions);

        // Create an object with the captured data
        const visitorData = {
          country: locationData.country,
          city: locationData.city,
          date: currentDate,
          ip: locationData.ip,
        };

        // Send the data to Firebase store
        this.STORE_VISITOR_DATA(visitorData);
      } catch (error) {
        // console.error('Error capturing visitor information:', error);
      }
    },

    async captureLocation() {
      // console.log('Before fetch'); 

      try {
        const response = await fetch('https://ipinfo.io/json?token=3b0d1097b02414');

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // console.log('After fetch'); 

        const data = await response.json();

        // console.log('ipinfo.io API response:', data); 

        const country = data.country || 'Unknown';
        const city = data.city || 'Unknown';
        const ip = data.ip || 'Unknown';
        const locationData = { country, city, ip };

        localStorage.setItem('locationDataCache', JSON.stringify(locationData));

        // console.log('Captured Location Data:', locationData); 

        return locationData;
      } catch (error) {
        // console.error('Error getting location data:', error);
        return { country: 'Unknown', city: 'Unknown', ip: 'Unknown' };
      }
    },

    toggleTheme() {
      this.TOGGLE_DARK_MODE()
    },

    updateActiveLinkOnScroll() {
      const scrollPosition = window.scrollY;

      // Adjust these values based on your layout and styling
      const sections = {
        home: document.getElementById('home').offsetTop,
        about: document.getElementById('about').offsetTop,
        services: document.getElementById('services').offsetTop,
        skills: document.getElementById('skills').offsetTop,
        projects: document.getElementById('projects').offsetTop,
        contact: document.getElementById('contact').offsetTop,
      };

      // Find the active section based on scroll position
      let activeSection = null;
      for (const [section, offset] of Object.entries(sections)) {
        if (scrollPosition >= offset && scrollPosition < offset + window.innerHeight) {
          activeSection = section;
          break;
        }
      }

      this.activeLink = activeSection;
    },

  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveLinkOnScroll);

    window.removeEventListener('scroll', this.setDocumentTitle);

  },

  computed: {
    ...mapState(['isDarkMode']),
    isMobile() {
      return window.innerWidth <= 768
    }
  }

}
</script>


<style lang="scss" scoped>
.home {
  background: rgba(255, 255, 255, 0.904);

  .fa-sun:hover {
    animation: spin 1s forwards linear;
  }

  .fa-moon:hover {
    color: gray;
    animation: bounce 0.6s forwards linear;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }


  @keyframes bounce {

    0%,
    100% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(-60deg);
    }
  }


  // p {
  //   color: rgb(68, 68, 68);
  // }

  header {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 5%;
    background: rgba(255, 255, 255, 0.37);
    backdrop-filter: blur(8px);
    height: 15vh;
    z-index: 19999;

    .logo {
      font-size: 1.7rem;
      letter-spacing: 1px;
      color: black;

      &:hover {
        cursor: default;
      }
    }

    .mode {
      position: absolute;
      right: 1%;
      padding: 0 1rem;
      cursor: pointer;

      i {
        color: black;
        font-size: 1.2rem;
      }
    }

    .nav-menu {

      ul {
        display: flex;

        li {
          a {
            padding: 10px 20px;
            font-size: 1.2rem;
            font-weight: 400;
            color: black;


            &:hover {
              text-shadow: 0 0 10px rgba(13, 0, 0, 1),
                0px 0px 21px rgba(13, 0, 0, 0.78),
                0px 0px 24px rgba(13, 0, 0, 0.82),
                0px 1px 4px rgba(13, 0, 0, 0.16);
            }
          }
        }
      }
    }

    .menu-icon {
      font-size: 1.5rem;
      cursor: pointer;
      padding: 0;
      font-weight: 400;
      display: none;

      i {
        color: black;
      }

      &:hover {
        text-shadow: 0 0 10px rgba(13, 0, 0, 1),
          0px 0px 21px rgba(13, 0, 0, 0.78),
          0px 0px 24px rgba(13, 0, 0, 0.82),
          0px 1px 4px rgba(13, 0, 0, 0.16);
      }
    }


    @media (max-width: 1100px) {
      .menu-icon {
        display: block;
        transition: all .4s ease;
      }

      .mode {
        right: 10%;
      }

      .nav-menu {
        position: absolute;
        min-height: 100vh;
        top: 100%;
        right: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.829);
        z-index: 909;
        transition: all .7s ease;
        overflow: hidden;

        ul {
          display: flex;
          flex-direction: column;
          background: rgba(202, 202, 202, 0.753);
          backdrop-filter: blur(8px);
          text-align: left;
          padding: 0 5%;
          transition: all .45s ease;
          padding-top: 2rem;
          padding-bottom: 5rem;
          border-bottom-right-radius: 40px;
          border-bottom-left-radius: 40px;

          li {

            a {
              display: block;
              padding-bottom: 1rem;
              font-size: 1.3rem;
            }
          }
        }

      }

      .menu-hidden {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease-in-out, pointer-events 0.3s step-end;
      }
    }

    @media (max-width: 750px) {
      .logo {
        font-size: 1.4rem;
      }

      .menu-icon {
        font-size: 1.3rem;
      }
    }

  }

  // -----------------------  LANDING SECTION  ----------------------- //
  .landing {
    // padding: 0 15%;
    margin-top: 0;

    .container {
      width: 100%;
      min-height: 100vh;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
      grid-gap: 4em;

      .content {
        max-width: 600px;
        z-index: 99;

        h3 {
          font-size: 2.5rem;
          font-weight: 600;
          color: rgb(90, 90, 90);

          span {
            font-size: 3rem;
            font-weight: 700;
            color: black;
          }
        }

        h4 {
          font-size: 1.7rem;
          font-weight: 600;
          color: rgb(90, 90, 90);

          span {
            font-size: 1.7rem;
            font-weight: 700;
            color: black;
            white-space: nowrap;
          }
        }

        p {
          font-size: 1.2rem;
          line-height: 1.6;
        }

        .btn-box {
          display: flex;
          justify-content: space-between;
          width: 320px;
          height: 45px;
          margin: 1.5rem 5%;
          gap: 1.2rem;

          .btn {
            position: relative;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 150px;
            height: 100%;
            background: rgba(255, 255, 255, 0.37);
            backdrop-filter: blur(8px);
            color: black;
            font-size: 1rem;
            letter-spacing: 1px;
            font-weight: 600;
            transition: .6s;
            border-radius: 10px;
            overflow: hidden;
            z-index: 1;
            border: 2px solid black;

            &::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              background: black;
              width: 0;
              height: 100%;
              z-index: -1;
              transition: .3s;

            }

            &:hover::before {
              width: 100%;
            }

            &:hover {
              box-shadow: 0 0 10px rgba(13, 0, 0, 1),
              0px 0px 21px rgba(13, 0, 0, 0.078),
              0px 0px 24px rgba(13, 0, 0, 0.082),
              0px 1px 4px rgba(13, 0, 0, 0.016);

              @media(max-width: 750px) {
                box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                0px 0px 25px rgba(13, 0, 0, 0.6);
              }
              color: white;
            }

            &:nth-child(2) {
              background: black;
              color: white;


              &::before {
                background: rgba(255, 255, 255, 0.164);
                backdrop-filter: blur(8px);
              }

              &:hover {
                background: rgba(255, 255, 255, 0.37);
                backdrop-filter: blur(8px);
                color: black;
              }
            }
          }
        }

        .socials {
          margin: 3rem 10%;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          gap: 1rem;
          max-width: 250px;
          width: 100%;
          height: 40px;

          a {
            display: inline-flex;
            width: 50px;
            height: 100%;
            justify-content: center;
            align-items: center;
            background: rgba(255, 255, 255, 0.37);
            backdrop-filter: blur(8px);
            border: 2px solid black;
            transition: .6s;
            border-radius: 5px;
            position: relative;
            z-index: 1;
            overflow: hidden;

            i {
              font-size: 1.4rem;
              color: black;
            }

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 0;
              height: 100%;
              background: black;
              transition: .4s;
              z-index: -1;
            }

            &:hover::before {
              width: 100%;
            }

            &:hover {
              i {
                color: white;
              }

              box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                0px 0px 21px rgba(13, 0, 0, 0.078),
                0px 0px 24px rgba(13, 0, 0, 0.082),
                0px 1px 4px rgba(13, 0, 0, 0.016);

                @media(max-width: 750px) {
                  box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                  0px 0px 25px rgba(13, 0, 0, 0.6);
                }
            }
          }
        }
      }

      .landing-image {
        position: relative;
        z-index: 99;

        .img-box {
          text-align: center;

          img {
            width: 100%;
            max-width: 350px;
            height: auto;
            border-radius: 20px;
          }
        }

        .bubble {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: -1;
          top: 10%;
        }

        path {
          fill: rgba(0, 0, 0, 0.774);
        }

        .bubble:nth-child(2) {
          filter: blur(50px);
        }
      }
    }

    @media(max-width: 990px) {

      .container {

        .content {
          margin-top: 5rem;

          h3 {
            font-size: 1.5rem;

            span {
              font-size: 2rem;
            }
          }

          h4 {
            font-size: 1.2rem;

            span {
              font-size: 1.5rem;
            }
          }

          p {
            font-size: 1.1rem;
            line-height: 1.5;
          }

          .btn-box {
            width: 250px;
            height: 40px;

            .btn {
              width: 100%;
              height: 100%;
              font-size: .8rem;
            }
          }

          .socials {
            margin: 1rem 5%;

            a {
              i {
                font-size: 1rem;
              }
            }
          }
        }

      }
    }

    @media(max-width: 760px) {

      .container {
        grid-template-columns: 1fr;

        .content {
          margin-top: 8rem;
        }

        .landing-image {
          margin-bottom: 5rem;

          .bubble {
            width: 100%;
            height: 100%;
            top: 13%;
          }
        }
      }
    }

    @media(max-width: 520px) {

      .container {
        .content {
          margin-top: 8rem;
        }

        .landing-image {
          margin-bottom: 5rem;

          .img-box {

            img {
              width: 250px;
            }
          }

        }
      }
    }
  }

  // x-----------------------  LANDING SECTION  -----------------------x //

  // -----------------------  CONTACT SECTION  ----------------------- //
  .contact {
    // padding: 0 15%;

    .container {
      padding-top: 4vh;
      width: 100%;
      min-height: 100vh;
      height: 100%;

      .form {

        form {
          text-align: center;
          max-width: 50rem;
          margin: 1rem auto;
          margin-bottom: 3rem;
          position: relative;

          input,
          textarea {
            width: 100%;
            background: rgba(43, 42, 42, 0.315);
            backdrop-filter: blur(9px);
            color: black;
            margin-bottom: 0.8rem;
            border: none;
            border-radius: 5px;
            padding: .7rem;

            &:focus {
              outline: rgba(109, 109, 109, 0.616);
            }

            &::placeholder {
              color: black;
            }
          }

          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* For Firefox */
          input[type="number"] {
            -moz-appearance: textfield;
          }

          textarea {
            resize: none;
          }

          .form-btn {
            display: flex;
            justify-content: center;
            width: 100%;

            .btn {
              position: relative;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              padding: .8rem 1.2rem;
              width: 200px;
              height: 100%;
              background: rgba(255, 255, 255, 0.322);
              backdrop-filter: blur(8px);
              color: black;
              font-size: 1rem;
              letter-spacing: 1px;
              font-weight: 500;
              transition: .6s;
              border-radius: 10px;
              overflow: hidden;
              z-index: 1;
              border: 2px solid black;
              cursor: pointer;

              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                background: black;
                width: 0;
                height: 100%;
                z-index: -1;
                transition: .4s;

              }

              &:hover::before {
                width: 100%;
              }

              &:hover {
                box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                0px 0px 21px rgba(13, 0, 0, 0.078),
                0px 0px 24px rgba(13, 0, 0, 0.082),
                0px 1px 4px rgba(13, 0, 0, 0.016);

                @media(max-width: 750px) {
                  box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                  0px 0px 25px rgba(13, 0, 0, 0.6);
                }
                color: white;
              }
            }

            @keyframes shake {

              0%,
              100% {
                transform: translateX(0);
              }

              10%,
              30%,
              50%,
              70%,
              90% {
                transform: translateX(-10px);
              }

              20%,
              40%,
              60%,
              80% {
                transform: translateX(10px);
              }
            }

            .shake {
              animation: shake 1s ease-in-out;
            }

          }

          .modal {
            position: absolute;
            z-index: 100;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // overflow: auto;
            background: rgba(255, 255, 255, 0.096);
            backdrop-filter: blur(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            border-radius: 10px;

            .modal-content {
              margin: 15% auto;
              padding: 20px;

              p {
                color: black;
              }
            }

            .close {
              position: absolute;
              top: 0;
              right: 10px;
              float: right;
              font-size: 28px;
              cursor: pointer;

              i {
                color: black;
                transition: .6s ease;

                &:hover {
                  color: red;
                }
              }
            }

            .tick-container {
              display: inline-block;
              position: relative;
            }
          }
        }
      }
    }
  }

  // x-----------------------  CONTACT SECTION  -----------------------x //


  .footer {
    p {
      text-align: center;
      font-size: 18px;
      z-index: 200;
      position: relative;
      color: black;

      a {
        cursor: pointer;
        color: black;

        &:hover {
          color: red;
        }
      }
    }


    @media (max-width: 900px) {
      p {
        font-size: 90%;
        width: 100%;
        text-align: center;
        padding: .8rem 0;
      }
    }
  }
}


.dark-mode {
  background-color: black;
  color: white;

  p {
    color: rgb(126, 126, 126);
  }

  .intro {
    h1 {
      color: white;
    }
  }

  header {
    background: rgba(255, 255, 255, 0.096);
    backdrop-filter: blur(8px);

    .logo {
      color: white;
    }

    .mode {
      i {
        color: white;
      }
    }

    .nav-menu {
      ul {
        li {
          a {
            color: white;

            &:hover {
              text-shadow: 0px 0px 19px rgba(242, 242, 242, 0.61),
                0px 0px 24px rgba(240, 242, 240, 0.63),
                0px 0px 23px rgba(242, 242, 237, 1),
                0px 0px 22px rgba(242, 242, 242, 0.97),
                1px 1px 25px rgba(242, 242, 242, 1),
                0px 0px 24px rgba(181, 181, 181, 1),
                0px 0px 24px rgba(155, 155, 155, 1);
            }
          }
        }
      }
    }

    .menu-icon {
      i {
        color: white;
      }

      &:hover {
        text-shadow: 0px 0px 19px rgba(242, 242, 242, 0.61),
          0px 0px 24px rgba(240, 242, 240, 0.63),
          0px 0px 23px rgba(242, 242, 237, 1),
          0px 0px 22px rgba(242, 242, 242, 0.97),
          1px 1px 25px rgba(242, 242, 242, 1),
          0px 0px 24px rgba(181, 181, 181, 1),
          0px 0px 24px rgba(155, 155, 155, 1);
      }
    }

    @media (max-width: 1100px) {
      .nav-menu {
        ul {
          background: rgba(90, 90, 90, 0.233);
          backdrop-filter: blur(8px);
        }
      }
    }
  }

  .landing {
    .container {
      .content {

        h3 {
          color: rgb(199, 197, 197);

          span {
            color: white;
          }
        }

        h4 {
          color: rgb(199, 197, 197);

          span {
            color: white;
          }
        }

        .btn-box {
          .btn {
            background: rgba(255, 255, 255, 0.322);
            backdrop-filter: blur(8px);
            color: white;
            border: 2px solid white;

            &::before {
              background: white;
            }

            &:hover {
              box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                0 0 21px rgba(255, 255, 255, 0.8),
                0 0 24px rgba(255, 255, 255, 0.6),
                0 0 4px rgba(255, 255, 255, 0.4);

                @media(max-width: 750px) {
                    box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                    0 0 25px rgba(255, 255, 255, 0.6);
                }
              color: black;
            }

            &:nth-child(2) {
              background: white;
              color: black;

              &::before {
                background: rgba(255, 255, 255, 0.164);
                backdrop-filter: blur(8px);
              }

              &:hover {
                background: rgba(255, 255, 255, 0.164);
                backdrop-filter: blur(8px);
                color: white;
              }
            }
          }
        }

        .socials {
          a {
            background: rgba(255, 255, 255, 0.322);
            backdrop-filter: blur(8px);
            border: 2px solid white;

            i {
              color: white;
            }

            &::before {
              background: white;

            }

            &:hover::before {
              width: 100%;
            }

            &:hover {
              i {
                color: black;
              }

              box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                0 0 21px rgba(255, 255, 255, 0.8),
                0 0 24px rgba(255, 255, 255, 0.6),
                0 0 4px rgba(255, 255, 255, 0.4);

                @media(max-width: 750px) {
                    box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                    0 0 25px rgba(255, 255, 255, 0.6);
                }
            }
          }
        }
      }

      .landing-image {
        .bubble {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: -1;
          top: 10%;
        }

        path {
          fill: white;
        }



        .bubble:nth-child(2) {
          filter: blur(50px);
        }
      }
    }
  }

  .contact {
    .container {
      .form {

        form {

          input,
          textarea {
            width: 100%;
            background: rgba(255, 255, 255, 0.164);
            backdrop-filter: blur(9px);
            color: white;
            margin-bottom: 0.8rem;
            border: none;
            border-radius: 5px;
            padding: .7rem;

            &:focus {
              outline: rgba(179, 179, 179, 0.616);
            }

            &::placeholder {
              color: white;
            }
          }

          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* For Firefox */
          input[type="number"] {
            -moz-appearance: textfield;
          }

          textarea {
            resize: none;
          }

          .form-btn {
            .btn {
              background: rgba(255, 255, 255, 0.322);
              backdrop-filter: blur(8px);
              color: white;
              border: 2px solid white;


              &::before {
                background: white;
              }

              &:hover::before {
                width: 100%;
              }

              &:hover {
                box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                0 0 21px rgba(255, 255, 255, 0.8),
                0 0 24px rgba(255, 255, 255, 0.6),
                0 0 4px rgba(255, 255, 255, 0.4);

                @media(max-width: 750px) {
                    box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                    0 0 25px rgba(255, 255, 255, 0.6);
                }
                color: black;
              }
            }
          }

          .modal {
            .modal-content {
              p {
                color: white;
              }
            }

            .close {
              i {
                color: white;
                transition: .6s ease;

                &:hover {
                  color: red;
                }
              }
            }

            .tick-container {
              display: inline-block;
              position: relative;
            }
          }
        }
      }
    }
  }

  .footer {
    p {
      color: white;

      a {
        color: white;
      }
    }
  }
}
</style>

